
export default {
  name: "RetornavelProdutoModal",
  data() {
    return {
      produto: {},
      quantidade: 0,
      quantidadeRetornada: 0,
      precoComRetorno: 0,
      resolver: null,
    };
  },
  computed: {
    precoSemRetorno() {
      return Number(this.produto.preco_sem_retorno) || 0;
    },
    quantidadeComRetorno() {
      const quantidade = Number(this.quantidadeRetornada);
      return Number.isInteger(quantidade) && quantidade >= 0
        ? Math.min(quantidade, this.quantidade)
        : 0;
    },
    quantidadeSemRetorno() {
      return this.quantidade - this.quantidadeComRetorno;
    },
  },
  methods: {
    abrir({ produto, quantidade, preco }) {
      if (this.resolver) {
        this.resolver(null);
      }

      this.produto = produto || {};
      this.quantidade = Number(quantidade) || 0;
      this.quantidadeRetornada = this.quantidade;
      this.precoComRetorno = Number(preco) || 0;

      this.$refs.modal.show();
      this.$nextTick(() => {
        const input = this.$refs.quantidadeRetornada;
        if (input?.$el) input.$el.focus();
      });

      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    confirmar() {
      const quantidade = Number(this.quantidadeRetornada);

      if (
        !Number.isInteger(quantidade) ||
        quantidade < 0 ||
        quantidade > this.quantidade
      ) {
        this.$toast.warning(
          `Informe uma quantidade inteira entre 0 e ${this.quantidade}.`
        );
        return;
      }

      this.finalizar(quantidade);
    },
    cancelar() {
      this.finalizar(null);
    },
    finalizar(resultado) {
      const resolver = this.resolver;
      this.resolver = null;
      if (resolver) resolver(resultado);
      this.$refs.modal.hide();
    },
    aoFechar() {
      if (this.resolver) {
        this.resolver(null);
        this.resolver = null;
      }
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor) || 0);
    },
  },
};
